<template>
  <BaseTable
    :headers="[
      $t('global.name'),
      $t('global.email'),
      $t('global.address'),
      $t('global.postal_code'),
      $t('global.total_inventory'),
    ]"
    :rows="
      suppliers.map((supplier) => ({
        id: supplier.id,
      cells: [
        supplier.name,
        supplier.email,
        supplier.address,
        supplier.postalcode,
        supplier.totalInventory ? {
          value: filters.currency(supplier.totalInventory),
          type: 'currency'
        } : null,
      ],
      actions: getActions()
    }))
    "
    @action="onAction"
    v-test="'suppliers'"
  ></BaseTable>
</template>

<script
  setup
  lang="ts"
>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import filters from '@/filters';
import { useUserStore } from '@/stores/user';

const { t } = useI18n();
const { hasFeatureFlag } = useUserStore();
const router = useRouter();

interface SupplierItem {
  id: number;
  name: string;
  email: string;
  address: string;
  postalcode: string;
  totalInventory: number;
  amountProducts: number;
}

const suppliers = inject<Ref<SupplierItem[]>>('page-items');

const getActions = () => [
  {
    name: 'edit',
    icon: 'edit',
    label: t('global.actions.edit'),
  },
  ...(hasFeatureFlag('product-delete')
    ? [
        {
          name: 'delete',
          icon: 'delete',
          label: t('global.actions.delete'),
        },
      ]
    : []),
];

const onAction = ({ id, option }) => {
  const supplier = suppliers?.value.find((supplier) => supplier.id === id);
  if (option === 'edit') {
    router.push({
      name: 'edit-supplier',
      params: { id },
    });
  }

  if (option === 'delete') {
    router.push({
      name: 'delete-supplier',
      params: { id },
      query: {
        products: supplier?.amountProducts,
      },
    });
  }
};
</script>
